import { atom } from "jotai";

export interface IZone {
    id?: number;
    zone_group_id: number;
    code: string;
    name?: string | null;
    is_active?: boolean;
    width?: number | null;
    height?: number | null;
    length?: number | null;
    x?: number | null;
    y?: number | null;
    z?: number | null;
    created_at?: string;
    updated_at?: string;
}

export interface IZoneInput extends Omit<IZone, 'id' | 'created_at' | 'updated_at'> {}

export const zonesAtom = atom<IZone[]>([]);
export const zonesLoadingAtom = atom<boolean>(false);

